// sseService.ts
export const sseService = {
	connect() {
		/* SSE connection logic */
	},
	searchItineraries() {
		/* SSE data fetching logic */
	},
	searchEvents() {
		/* SSE logic */
	},
};
